// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "" + ({"398": "OLparser","739": "BufferOp",}[chunkId] || chunkId) + ".bundle.js"
}// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "" + ({"398": "OLparser","739": "BufferOp",}[chunkId] || chunkId) + ".bundle.js"
}